import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import Form from "./Form";
import ShipmentDetails from "../../common/ShipmentDetails";
import appConstants from "../../../../../../../appConstants";
import { PAYMENT_MODES } from "../../common/constants";
import { observer, inject } from "mobx-react";
import ShipmentCard from "./ShipmentsCard";
import { withSnackbar } from "notistack";
import { StyledRadioGroup } from "../../common/RadioGroup";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import CustomConfirmationDialog from "../../common/CustomConfirmationDialog";
import {
  getDefaultDeliveryStopInfo,
  getDefaultStopTimeInfo,
  getStopTimeErrorInfo,
  isStopTimeDetailsInValid,
  getStopTimeFieldError,
  getShipmentFreightBill,
  getExcessiveLengthError,
} from "../util";
import { formatAddress, getPendingStops } from "../../../../utils/utils";
import StopDetailsTitle from "../../common/StopDetailsTitle";
import SwitchWithLabel from "../../common/CustomSwitch";
import Action from "../common/Action";
import StopWindowDetails from "../../common/StopWindowDetails";
import { getDateWithUtcHoursAndMinFromTimeString } from "../../../../../../../components/dataGrid/gridUtilities";
import SelectBills from "./SelectBills";
import { getAccessorialsAfterExclusion } from "./../../../DriverPopUp/common/utils";
import {
  getPaymentErrorInfo,
  isPaymentDetailsRequired,
  populatePaymentAmount,
} from "./../Payment/util";
import { withExceptionDetailsHOC } from "./ExceptionDetail";

@inject("DispatchStore")
@observer
class ProcessDelivery extends React.Component {
  constructor(props) {
    const {
      processDeliveryData,
      stopData: { actualArrivalTime },
    } = props;
    super(props);
    this.state = {
      editBillsDataArray:
        processDeliveryData?.editBillsDataArray ??
        getDefaultDeliveryStopInfo(
          this.props.stopData,
          this.props.deliveryException.getDefaultExceptionDetail
        ),
      errorMessage: null,
      allStatusRadioClicked:
        processDeliveryData?.allStatusRadioClicked ?? false,
      showConfirmDialog: false,
      showDeliveryReceipt: false,
      isDriverAllowedInside: processDeliveryData?.isDriverAllowedInside ?? true,
      stopTimeInfo:
        processDeliveryData?.stopTimeInfo ??
        getDefaultStopTimeInfo(props.isDriverArrived, actualArrivalTime),
      editStopsList: [this.props.stopData],
      isArrivalDepartureTimeRequired: true,
    };
    this.inputRefs = [];
  }
  setRef = (ref) => {
    this.inputRefs.push(ref);
  };

  componentDidUpdate(prevProps) {
    if (this.props.isDriverArrived !== prevProps.isDriverArrived) {
      this.setNewArrivalStopTime();
    }
  }

  setNewArrivalStopTime = () => {
    const {
      isDriverArrived,
      stopData: { actualArrivalTime },
    } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      stopTimeInfo: {
        ...prevState.stopTimeInfo,
        stopTime: {
          ...prevState.stopTimeInfo.stopTime,
          arrivalTime:
            isDriverArrived && actualArrivalTime
              ? getDateWithUtcHoursAndMinFromTimeString(actualArrivalTime)
              : null,
        },
      },
    }));
  };

  clearSelections = (proId) => {
    let newBillList = [];
    this.state.editBillsDataArray.forEach((pro) => {
      if (pro.proId === proId) {
        let editInfo = {
          ...pro.editInfo,
          exceptionType: "",
          returnCode: "",
          customerName: null,
          ...this.props.deliveryException.getDefaultExceptionDetail(),
        };
        newBillList.push({ ...pro, editInfo: editInfo, errorInfo: {} });
      } else {
        newBillList.push({ ...pro });
      }
    });
    this.setState({
      editBillsDataArray: newBillList,
      editStopsList: [this.props.stopData],
    });
  };

  resetReturnCodeFields = (fieldName, value) => {
    switch (fieldName) {
      case "returnCode":
        return {
          customerName: null,
          ...this.props.deliveryException.getDefaultExceptionDetail(),
        };
      case "deliveryStatus":
        return [appConstants.DELIVERY_CODE.SND, appConstants.DELIVERY_CODE.RTN].includes(value) 
          ? {
              isShrinkWrap: false,
              palletCount: null,
              isExcessiveLength: appConstants.EXCESSIVE_SHIPMENT.NO,
              excessiveLength: null,
            }
          : { isShrinkWrap: false, returnCode: null };
      case "isExcessiveLength":
        return { excessiveLength: null };
      case "isShrinkWrap":
        return { palletCount: null };
      default:
        return {};
    }
  };

  handleChange = (proId) => (name) => (value) => {
    let newBillList = [],
      populatedPaymentInfo = {};
    this.state.editBillsDataArray.forEach((pro) => {
      if (pro.proId === proId) {
        let resetFrieghtCheckNumber = null;
        if (["freightPaymentType", "codPaymentType"].includes(name)) {
          const shipmentObj = this.getShipmentData(proId);
          populatedPaymentInfo = populatePaymentAmount({
            freightAmount: shipmentObj?.freightAmount,
            codAmount: shipmentObj?.codAmount,
            paymentTypeFieldName: name,
            paymentTypeValue: value,
          });
        }

        if (
          name === "freightPaymentType" &&
          value.value !== PAYMENT_MODES.FREIGHT_PAYMENT_MODES.CHECK
        ) {
          resetFrieghtCheckNumber = { freightCheckNumber: null };
        }

        let editInfo = {
          ...pro.editInfo,
          ...populatedPaymentInfo,
          ...this.resetReturnCodeFields(name, value),
          ...resetFrieghtCheckNumber,
          [name]: value,
        };
        const errorInfo = {
          ...pro.errorInfo,
          [name]: this.getFieldError(proId, name, value),
        };
        newBillList.push({ ...pro, editInfo: editInfo, errorInfo: errorInfo });
      } else {
        newBillList.push({ ...pro });
      }
    });
    const isArrivalDepartureTimeRequired = this.getIsArrivalDepartureTimeRequired(newBillList);
    this.setState(
      (prevState) => ({
        editBillsDataArray: newBillList,
        isArrivalDepartureTimeRequired,
        stopTimeInfo: this.getUpdatedStopTimeInfo(
          isArrivalDepartureTimeRequired,
          prevState
        ),
      }),
      () => {
        if (name === "deliveryStatus") {
          this.clearSelections(proId);
        }
      }
    );
  };

  getUpdatedStopTimeInfo = (isArrivalDepartureTimeRequired, prevState) => {
    const {
      stopData: { actualArrivalTime },
      isDriverArrived,
    } = this.props;
    if (isArrivalDepartureTimeRequired) {
      return isDriverArrived
        ? getDefaultStopTimeInfo(
            isDriverArrived,
            actualArrivalTime,
            this.state.stopTimeInfo.stopTime.departureTime
          )
        : prevState.stopTimeInfo;
    }
    return getDefaultStopTimeInfo();
  }

  getIsArrivalDepartureTimeRequired = (billsData) => {
    // if atleast one of the pro needs arrivalDeparture time
    return billsData.reduce((isArrivalDepartureTimeRequired, proData) => {
      let isArrivalDepartureTimeRequiredForPro = true;
      if (proData.editInfo.exceptionType) {
        isArrivalDepartureTimeRequiredForPro =
          this.props.DispatchStore.getExceptionDetails(
            proData.editInfo.exceptionType
          )?.isArrivalDepartureTimeRequired;
      } else if (proData.editInfo.returnCode) {
        isArrivalDepartureTimeRequiredForPro =
          this.props.DispatchStore.getReturnDetails(
            proData.editInfo.returnCode
          )?.isArrivalDepartureTimeRequired;
      }
      return (
        isArrivalDepartureTimeRequired || isArrivalDepartureTimeRequiredForPro
      );
    }, false);
  };

  handleIsDriverAllowedChange = (value) => {
    this.setState({
      isDriverAllowedInside: value,
    });
  };

  handleStopTimeChange = (name) => (value) => {
    this.setState(
      (prevState) => ({
        stopTimeInfo: {
          ...prevState.stopTimeInfo,
          stopTime: {
            ...prevState.stopTimeInfo.stopTime,
            [name]: value,
          },
        },
      }),
      () => {
        this.updateStopTimeErrors(name);
      }
    );
  };

  updateStopTimeErrors = (name) => {
    this.setState((prevState) => {
      const prevStopTime = prevState.stopTimeInfo.stopTime;
      const prevStopError = prevState.stopTimeInfo.stopTimeError;
      return {
        stopTimeInfo: {
          ...prevState.stopTimeInfo,
          stopTimeError: {
            arrivalTime:
              name === "arrivalTime"
                ? getStopTimeFieldError(
                    "arrivalTime",
                    prevStopTime.arrivalTime,
                    prevStopTime
                  )
                : prevStopError.arrivalTime,
            departureTime:
              name === "departureTime" || prevStopTime.departureTime
                ? getStopTimeFieldError(
                    "departureTime",
                    prevStopTime.departureTime,
                    prevStopTime
                  )
                : prevStopError.departureTime,
          },
        },
      };
    });
  };

  submitAllProsOnConfirm = () => {
    let newBillList = [];
    this.state.editBillsDataArray.forEach((pro) => {
      let editInfo = {
        ...pro.editInfo,
        deliveryStatus: this.state.allProDelStatusCode,
      };
      newBillList.push({ ...pro, editInfo: editInfo, errorInfo: {} });
    });
    this.setState({
      editBillsDataArray: newBillList,
      showConfirmDialog: false,
    });
  };

  updateStopSelection = (selectedStops) => {
    this.setState({ editStopsList: [...selectedStops] });
  };

  getPaymentDetailsObject = (editInfo) => {
    return {
      freightAmount: editInfo.freightAmountCollected,
      freightCheckNumber: editInfo.freightCheckNumber,
      codAmount: editInfo.codAmountCollected,
      codCheckNumber: editInfo.codCheckNumber,
      codPaymentType: editInfo.codPaymentType?.value ?? null,
      freightPaymentType: editInfo.freightPaymentType?.value ?? null,
    };
  };

  getDeliveryStatus = (value) => {
    return this.props.DispatchStore.deliveryStatuses.find(
      (item) => item.value === value
    )?.labelText;
  };

  cancelStopCompletion = () => {
    this.setState({
      showConfirmDialog: false,
    });
  };

  allProsMarkedTA = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) => pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.TA
    );
  };

  getOtherStopsData = (stop) => {
    return stop.shipments.map((shipment) => ({
      editProData: {
        proNumber: shipment.proId,
        accessorials: [],
        palletCount: null,
        isShrinkWrap: null,
        excessiveLength: null,
        deliveryCode: appConstants.DELIVERY_CODE.TA,
      },
      shipmentData: shipment,
    }));
  };

  getAccessorialsArray = (editInfo) => {
    if ([appConstants.DELIVERY_CODE.SND, appConstants.DELIVERY_CODE.RTN].includes(editInfo.deliveryStatus)) {
      return [];
    }
    const { accessorialExclusionList } =
      this.props.DispatchStore.getStaticClientData().clientCodes;
    const selectedAccessorials = editInfo.accessorials
      .filter((accessorial) => accessorial.isChecked)
      .map((accessorial) => accessorial.name);
    return selectedAccessorials.length === 0
      ? selectedAccessorials
      : getAccessorialsAfterExclusion({
          selectedAccessorials,
          accessorialExclusionList,
          isLiftgateTrailer: this.props.routeData.trailer.isLiftGate,
        });
  };

  populateRequestObj = (data) => {
    const { editInfo, proId } = data;
    let editProData = {};
    let deliveryStatusObj = {};
    editProData.proNumber = proId;
    const shipmentObj = this.getShipmentData(proId);
    const payment = isPaymentDetailsRequired({
      deliveryStatus: editInfo.deliveryStatus,
      codAmount: shipmentObj?.codAmount,
      freightAmount: shipmentObj?.freightAmount,
    });
    if (payment) {
      deliveryStatusObj.payment = this.getPaymentDetailsObject(editInfo);
    }
    if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DC) {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
    } else if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DE) {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
      deliveryStatusObj.exception = {
        code: editInfo.exceptionType,
        ...this.props.deliveryException.getExceptionDetail(editInfo),
      };
    } else if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN) {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
      deliveryStatusObj.return = {
        returnCode: editInfo.returnCode,
        customerName: editInfo.customerName,
        ...this.props.deliveryException.getExceptionDetail(editInfo),
      };
    } else {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
    }
    editProData = { ...editProData, ...deliveryStatusObj };
    editProData.accessorials = [...this.getAccessorialsArray(editInfo)];
    editProData.limitedAccessCode = editInfo.limitedAccessCode;
    editProData.isShrinkWrap = editInfo.isShrinkWrap ?? null;
    editProData.palletCount = editInfo.palletCount
      ? parseInt(editInfo.palletCount)
      : null;
    editProData.excessiveLength = editInfo.excessiveLength
      ? parseInt(editInfo.excessiveLength)
      : null;

    return { editProData, shipmentData: this.getShipmentData(proId) };
  };

  hasError = (errorInfo) => {
    const error = Object.values(errorInfo).filter((value) => value).length;
    return error > 0;
  };

  getFirstProMarkedTAOrSND = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.find((pro) =>
      [appConstants.DELIVERY_CODE.TA, appConstants.DELIVERY_CODE.SND].includes(
        pro.editInfo.deliveryStatus
      )
    );
  };

  allProsHaveSameStatus = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) =>
        pro.editInfo.deliveryStatus ===
        editBillsDataArray[0].editInfo.deliveryStatus
    );
  };

  allProsMarkedAsReturn = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) => pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN
    );
  };

  allProsMarkedAsSND = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) => pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.SND
    );
  };

  getProcessDeliveryUpdatedData = () => ({
    editBillsDataArray: this.state.editBillsDataArray,
    allStatusRadioClicked: this.state.allStatusRadioClicked,
    isDriverAllowedInside: this.state.isDriverAllowedInside,
    stopTimeInfo: this.state.stopTimeInfo,
  });

  getConfirmButtonTitle = () =>{
    if (this.allProsMarkedAsReturn()) {
      return "Update Return";
    }

    if (this.allProsMarkedAsSND()) {
      return "Update Delivery";
    }

    return "Create Delivery Receipt";
  }

  submitProData = () => {
    const stopTimeDetailsInfo = this.state.isArrivalDepartureTimeRequired
      ? getStopTimeErrorInfo(this.state.stopTimeInfo.stopTime)
      : getDefaultStopTimeInfo();

    this.setState({
      stopTimeInfo: stopTimeDetailsInfo,
    });
    const proMarkedTAorSND = this.getFirstProMarkedTAOrSND();
    if (
      this.isMultipleBillStop() &&
      !this.allProsHaveSameStatus() &&
      proMarkedTAorSND
    ) {
      this.setState({
        showConfirmDialog: true,
        allProDelStatusLabel: this.getDeliveryStatus(
          proMarkedTAorSND.editInfo.deliveryStatus
        ),
        allProDelStatusCode: proMarkedTAorSND.editInfo.deliveryStatus,
      });
      return;
    }
    const errorInfo = this.getErrorInfo();
    const finalDeliveryInfoList = [];
    const editBillsWithValError = [];
    errorInfo.forEach((errorInfoObj) => {
      const error = Object.values(errorInfoObj.errorInfo).filter(
        (value) => value
      ).length;
      error
        ? editBillsWithValError.push(
            this.inputRefs.find((ref) => ref.id === errorInfoObj.proId)
          )
        : finalDeliveryInfoList.push(this.populateRequestObj(errorInfoObj));
    });
    const isValError = editBillsWithValError.length > 0;
    const isStopTimeValError = this.state.isArrivalDepartureTimeRequired
      ? isStopTimeDetailsInValid(stopTimeDetailsInfo)
      : false;
    if (!isValError && !isStopTimeValError) {
      const proData = this.state.editStopsList.map((stop) => {
        const deliveryInfo =
          stop.stopId === this.props.stopData.stopId
            ? [...finalDeliveryInfoList]
            : [...this.getOtherStopsData(stop)];
        return {
          stop,
          deliveryInfo: deliveryInfo,
        };
      });
      this.props.submitProData({
        processDeliveryData: this.getProcessDeliveryUpdatedData(),
        proData,
        stopTimeDetails: this.state.stopTimeInfo,
        isDriverAllowedInside: this.state.isDriverAllowedInside,
        allProsMarkedTA: this.allProsMarkedTA(),
        isReturn: this.allProsMarkedAsReturn() || this.allProsMarkedAsSND(),
      });
    } else {
      editBillsWithValError[0]?.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  };

  isSelectedOSNDException = (editInfo) => {
    return this.props.DispatchStore.getExceptionDetails(editInfo.exceptionType)
      ?.isException;
  };

  isSelectedReturnCodeException = (editInfo) => {
    return this.props.DispatchStore.getReturnDetails(editInfo.returnCode)
      ?.isException;
  };

  validateExceptionDetails = (editInfo, name, value) => {
    if (
      this.isSelectedReturnCodeException(editInfo) ||
      this.isSelectedOSNDException(editInfo)
    ) {
      return this.props.deliveryException.validateExceptionDetail(name, value);
    }
    return null;
  };

  getFieldError = (proId, field, value) => {
    const { editBillsDataArray } = this.state;
    const { length: trailerLength } = this.props.routeData.trailer;
    let valueTrim;
    if (field !== "accessorials") {
      valueTrim = value;
    }
    const matchedProEditInfo = editBillsDataArray.find(
      (pro) => pro.proId === proId
    )?.editInfo;
    const shipmentObj = this.getShipmentData(proId);
    const paymentErrInfo = getPaymentErrorInfo({
      data: {
        deliveryStatus: matchedProEditInfo.deliveryStatus,
        freightPaymentType: matchedProEditInfo.freightPaymentType,
        freightAmount: shipmentObj?.freightAmount,
        codAmount: shipmentObj?.codAmount,
      },
      field,
      value: valueTrim,
    });
    if (matchedProEditInfo) {
      const isLimitedAccessChecked =
        matchedProEditInfo.accessorials.length > 0
          ? matchedProEditInfo.accessorials.find(
              (ele) => ele.name === appConstants.ACCESSORIAL.LIMITED_ACCESS
            )?.isChecked
          : false;
      if (this.props.deliveryException.exceptionDetailFields.includes(field)) {
        return this.validateExceptionDetails(
          matchedProEditInfo,
          field,
          valueTrim
        );
      } //validate field name based on customer flow requirement. 
      //we will get field name and validation function from customer flow and validate based on that
      switch (field) {
        case "deliveryStatus":
          return valueTrim ? null : "* Delivery Status is required";
        case "exceptionType":
          return matchedProEditInfo.deliveryStatus ===
            appConstants.DELIVERY_CODE.DE
            ? valueTrim
              ? null
              : "* OS & D Detail is required"
            : null;
        case "limitedAccessCode":
          return isLimitedAccessChecked &&
            matchedProEditInfo.deliveryStatus !== appConstants.DELIVERY_CODE.RTN
            ? value
              ? null
              : "* Limited Access is required"
            : null;
        case "returnCode":
          return matchedProEditInfo.deliveryStatus ===
            appConstants.DELIVERY_CODE.RTN
            ? valueTrim
              ? null
              : "* Return Code is required"
            : null;
        case "palletCount":
          return valueTrim || !matchedProEditInfo.isShrinkWrap
            ? null
            : "* Required";
        case "excessiveLength":
          return matchedProEditInfo.isExcessiveLength ===
            appConstants.EXCESSIVE_SHIPMENT.NO
            ? null
            : getExcessiveLengthError(valueTrim, trailerLength);
        case "customerName":
          return appConstants.SPECIAL_RETURNS.includes(
            matchedProEditInfo.returnCode
          )
            ? valueTrim
              ? null
              : "* Customer Name is required"
            : null;
        case "freightPaymentType":
        case "freightCheckNumber":
        case "freightAmount":
        case "codPaymentType":
        case "codCheckNumber":
        case "codAmount":
          return paymentErrInfo;
        default:
          return null;
      }
    }
  };

  getErrorInfo = () => {
    let errorInfo = {};
    const errorInfoList = [];
    let newBillList = [];
    this.state.editBillsDataArray.forEach((pro) => {
      Object.keys(pro.editInfo).forEach((fieldName) => {
        errorInfo[fieldName] = this.getFieldError(
          pro.proId,
          fieldName,
          pro.editInfo[fieldName]
        );
      });
      errorInfoList.push({ ...pro, errorInfo: errorInfo });
      newBillList.push({ ...pro, errorInfo: errorInfo });
      errorInfo = {};
    });
    this.setState({ editBillsDataArray: newBillList });
    return errorInfoList;
  };

  isMultipleBillStop = () => {
    return this.state.editBillsDataArray.length > 1;
  };

  getShipmentData = (proId) => {
    return this.props.stopData.shipments.find(
      (shipmentData) => shipmentData.proId === proId
    );
  };

  handleStatusForAllPros = (name) => (value) => {
    const updatedEditInfoArr = [];
    this.state.editBillsDataArray.forEach((pro) => {
      if (
        pro.editInfo.deliveryStatus === value ||
        !pro.editInfo.deliveryStatus
      ) {
        let editInfo = {
          ...pro.editInfo,
          [name]: value,
        };
        updatedEditInfoArr.push({ ...pro, errorInfo: {}, editInfo: editInfo });
      } else {
        updatedEditInfoArr.push({ ...pro });
      }
    });
    this.setState({
      editBillsDataArray: updatedEditInfoArr,
      allStatusRadioClicked: true,
    });
  };

  isDeliveryStatusUpdated = () => {
    return this.state.editBillsDataArray.some(
      (pro) => pro.editInfo.deliveryStatus
    );
  };

  render() {
    const {
      classes,
      handleClose,
      stopData,
      routeData,
      freightBillData,
      isDriverArrived,
    } = this.props;
    const { editBillsDataArray } = this.state;
    const deliveryStatusList = this.props.DispatchStore.deliveryStatuses;
    const stopHasMultiplePros = this.isMultipleBillStop();
    const allProsMarkedAsReturn = this.allProsMarkedAsReturn();
    return (
      <React.Fragment>
        <div className={classes.processDeliveryContent}>
          <StopDetailsTitle
            stopName={stopData.name}
            stopAddress={formatAddress({
              address: stopData?.address,
              address2: stopData?.address2,
              city: stopData?.city,
              state: stopData?.state,
              zip: stopData?.zip,
            })}
            driverNumber={routeData?.driverNumber}
          />
          <SwitchWithLabel
            rowLabel="Is driver allowed inside to complete delivery?"
            onChange={this.handleIsDriverAllowedChange}
            value={this.state.isDriverAllowedInside}
          />

          {!stopHasMultiplePros && !this.state.showDeliveryReceipt && (
            <React.Fragment>
              <ShipmentDetails
                shipmentData={stopData.shipments[0]}
                freightBillDetails={getShipmentFreightBill(
                  freightBillData,
                  editBillsDataArray[0].proId
                )}
              />
              <Form
                stopHasMultiplePros={stopHasMultiplePros}
                forwardRef={this.setRef}
                editInfo={editBillsDataArray[0].editInfo}
                updateStop={this.props.updateStop}
                routeData={routeData}
                stopData={stopData}
                shipmentData={stopData.shipments[0]}
                errorInfo={editBillsDataArray[0].errorInfo}
                handleChange={this.handleChange(editBillsDataArray[0].proId)}
                clearSelections={this.clearSelections}
                updateStopSelection={this.updateStopSelection}
              >
                <StopWindowDetails
                  disabled={!this.state.isArrivalDepartureTimeRequired}
                  arrivalTime={this.state.stopTimeInfo.stopTime.arrivalTime}
                  isArrivalTimeDisabled={isDriverArrived}
                  departureTime={this.state.stopTimeInfo.stopTime.departureTime}
                  arrivalTimeError={
                    this.state.stopTimeInfo.stopTimeError.arrivalTime
                  }
                  departureTimeError={
                    this.state.stopTimeInfo.stopTimeError.departureTime
                  }
                  handleChange={this.handleStopTimeChange}
                  timeWindow={stopData.deliveryWindow}
                  timeWindowLabel="Delivery Window"
                />
              </Form>
            </React.Fragment>
          )}
          {stopHasMultiplePros && !this.state.showDeliveryReceipt && (
            <div>
              <h4
                className={classes.deliveryBillsHeaderText}
              >{`Delivery Bills: ${stopData.numberOfBills}`}</h4>
              {editBillsDataArray.map((bill) => {
                const shipmentDataMulti = this.getShipmentData(bill.proId);
                return (
                  <ShipmentCard
                    stopHasMultiplePros={stopHasMultiplePros}
                    shipmentData={shipmentDataMulti}
                    forwardRef={this.setRef}
                    key={`shipment_card_${shipmentDataMulti.proId}`}
                    stopData={stopData}
                    editInfo={bill.editInfo}
                    routeData={routeData}
                    errorInfo={bill.errorInfo}
                    handleChange={this.handleChange}
                    deliveryStatusList={deliveryStatusList}
                    clearSelections={this.clearSelections}
                    deliveryStatus={{
                      deliveryStatus: bill.editInfo.deliveryStatus,
                      hasError: this.hasError(bill.errorInfo),
                    }}
                    freightBillDetails={getShipmentFreightBill(
                      freightBillData,
                      bill.proId
                    )}
                  />
                );
              })}
              {!this.isDeliveryStatusUpdated() &&
                !this.state.allStatusRadioClicked && (
                  <StyledRadioGroup
                    onChange={this.handleStatusForAllPros("deliveryStatus")}
                    options={deliveryStatusList.filter(
                      (list) =>
                        list.value !== appConstants.DELIVERY_CODE.RTN &&
                        list.value !== appConstants.DELIVERY_CODE.DE
                    )}
                    headerLabel="DELIVERY STATUS"
                  />
                )}
              <StopWindowDetails
                disabled={!this.state.isArrivalDepartureTimeRequired}
                arrivalTime={this.state.stopTimeInfo.stopTime.arrivalTime}
                isArrivalTimeDisabled={isDriverArrived}
                departureTime={this.state.stopTimeInfo.stopTime.departureTime}
                arrivalTimeError={
                  this.state.stopTimeInfo.stopTimeError.arrivalTime
                }
                departureTimeError={
                  this.state.stopTimeInfo.stopTimeError.departureTime
                }
                handleChange={this.handleStopTimeChange}
                timeWindow={stopData.deliveryWindow}
                timeWindowLabel="Delivery Window"
              />
              {this.allProsMarkedTA() && (
                <SelectBills
                  stopsList={getPendingStops(routeData.stops)}
                  currentStopData={stopData}
                  updateStopSelection={this.updateStopSelection}
                />
              )}
            </div>
          )}
        </div>
        <Action
          confirmButtonText={this.getConfirmButtonTitle()}
          isDisabled={
            allProsMarkedAsReturn && this.props.isProcessDeliveryInProgress
          }
          handleClose={handleClose}
          handleSubmit={this.submitProData}
        />
        {this.state.showConfirmDialog && (
          <CustomConfirmationDialog
            title={`All Pros ${this.state.allProDelStatusLabel}`}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Update All"
            onConfirm={this.submitAllProsOnConfirm}
            onCancel={this.cancelStopCompletion}
          >
            <div className={classes.confirmDialogContent}>
              <span>
                {`This action will update delivery statuses for all bills to ${this.state.allProDelStatusLabel}.`}
              </span>
              <span>Do you want to update all Pros?</span>
            </div>
          </CustomConfirmationDialog>
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar
)(withExceptionDetailsHOC(ProcessDelivery));
